<template>
  <v-container>
    <v-progress-linear
      v-if="isResolvingCustomer"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <v-alert v-if="customerLookupError" type="error">
      {{ customerLookupError }}
    </v-alert>
    <v-card v-if="isCustomerReady">
      <v-tabs
        v-model="tab"
        grow
        next-icon="mdi-arrow-right"
        prev-icon="mdi-arrow-left"
        show-arrows
        elevation="12"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="item in filteredTabs" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card>
            <v-card-text
              ><bus-entityinfo
                @selctedEntitytype="EntityType"
                @isHideform="isHideform"
            /></v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-text
              ><bus-applicantinfo
                :selctedEntity="selctedEntity"
                :is-active="filteredTabs[tab] === 'Representative Information'"
            /></v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="is_showAuthPage">
          <v-card>
            <v-card-text
              ><bus-authorization
                :selctedEntity="selctedEntity"
                :is-active="filteredTabs[tab] === 'Management Information'"
            /></v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text
              ><bus-documents
                :selctedEntity="selctedEntity"
                :hideForm="hideForm"
                :is-active="filteredTabs[tab] === 'Documents'"
            /></v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text
              ><bus-others :is-active="filteredTabs[tab] === 'Other'"
            /></v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text
              ><bus-declaration :is-active="filteredTabs[tab] === 'Declaration'"
            /></v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
<script>
import BusEntityinfo from "./BusEntityinfo.vue";
import BusApplicantinfo from "./BusApplicantinfo.vue";
import BusDocuments from "./BusDocuments.vue";
import BusOthers from "./BusOthers.vue";
import BusDeclaration from "./BusDeclaration.vue";
import { BusUserTypes } from "../../utils/BusDocuments";
import BusAuthorization from "../BusinessUserflow/BusAuthorization/BusAuthorization.vue";
import AgentService from "@/services/agentService/AgentService";
export default {
  data() {
    return {
      tab: null,
      items: [
        "Entity Information",
        "Representative Information",
        "Management Information",
        "Documents",
        "Other",
        "Declaration",
      ],
      selctedEntity: "",
      tabList: [],
      is_showAuthPage: true,
      buscheckboxes: BusUserTypes(),
      hideForm: "",
      isResolvingCustomer: false,
      customerLookupError: "",
      customerLookupVersion: 0,
    };
  },
  components: {
    BusEntityinfo,
    BusApplicantinfo,
    BusDocuments,
    BusOthers,
    BusDeclaration,
    BusAuthorization,
  },
  created() {
    this.tabList = [...this.items];
  },
  beforeDestroy() {
    this.customerLookupVersion += 1;
  },
  computed:{
    isCustomerReady() {
      return !this.$route.query.login_id || Boolean(this.$route.query.customer_id);
    },
    filteredTabs(){
      if(this.$route.query.login_id){
        return this.tabList;
      }else{
        return this.items.filter((item) => item === "Entity Information");
      }
    }
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler: "ensureCustomerId",
    },
  },
  methods: {
    async ensureCustomerId(query) {
      const version = ++this.customerLookupVersion;
      this.customerLookupError = "";
      this.isResolvingCustomer = false;
      if (!query.login_id || query.customer_id) return;

      this.isResolvingCustomer = true;
      try {
        const limit = 1000;
        for (let skip = 0; ; skip += limit) {
          const response = await AgentService.getCustomerList({
            customer_type: "BUS",
            skip,
            limit,
          });
          if (version !== this.customerLookupVersion) return;
          const customers = response?.data?.data;
          if (response?.data?.status_code !== 200 || !Array.isArray(customers)) {
            throw new Error("Could not load the business customer. Please try again.");
          }
          const customer = customers.find(
            (item) => String(item.login_id) === String(query.login_id)
          );
          if (customer?.customer_id) {
            await this.$router.replace({
              name: "Customer Business",
              query: { ...query, customer_id: customer.customer_id },
              hash: this.$route.hash,
            });
            return;
          }
          if (customer || customers.length < limit) {
            throw new Error("Business customer not found. Please reopen it from Customers List.");
          }
        }
      } catch (error) {
        if (version === this.customerLookupVersion) {
          this.customerLookupError = error?.message || "Could not load the business customer. Please try again.";
        }
      } finally {
        if (version === this.customerLookupVersion) {
          this.isResolvingCustomer = false;
        }
      }
    },
    EntityType(value) {
      this.selctedEntity = value;
      //to get boolean value of Authorization page required or not
      for (let doc in this.buscheckboxes) {
        console.log("doc integer", doc);
        if (doc === value) {
          console.log("doc mauin", this.buscheckboxes[doc]);
          this.is_showAuthPage = this.buscheckboxes[doc].is_authrequired;
        }
      }
      //to remove tab froms tab list
      if (!this.is_showAuthPage) {
        this.tabList = this.items.filter(
          (val) => val !== "Management Information"
        );
      } else {
        this.tabList = this.items;
      }
    },
    isHideform(value) {
      this.hideForm = value;
    },
  },
};
</script>
